import { computed, unref } from 'vue';
import { TOTAL_METRIC_GROUPS } from '@/app/dashboards/constants';
import {
  ADS_REPORT_AGGREGATE_BY_TYPES,
  LISTENING_REPORT_AGGREGATE_BY_TYPES,
  REPORT_PREVIEW_AGGREGATE_BY_TYPES,
} from '@/models/dashboards/aggregate-type.enum';

export function useReportMetaAggregateBy({ aggregateBy } = {}) {
  const reportAggregateBy = computed(() => unref(aggregateBy));

  const reportIsGroupedByChannel = computed(
    () => reportAggregateBy.value === TOTAL_METRIC_GROUPS.CHANNEL,
  );

  const reportIsGroupedByBrand = computed(
    () => reportAggregateBy.value === TOTAL_METRIC_GROUPS.BRAND,
  );

  const reportIsGroupedByCreator = computed(
    () => reportAggregateBy.value === TOTAL_METRIC_GROUPS.CREATOR,
  );

  const reportIsGroupedByGender = computed(
    () => reportAggregateBy.value === ADS_REPORT_AGGREGATE_BY_TYPES.AGE_GENDER.value,
  );

  const reportIsGroupedByPublisherPlatform = computed(
    () => reportAggregateBy.value === ADS_REPORT_AGGREGATE_BY_TYPES.PUBLISHER_PLATFORM.value,
  );

  const reportIsGroupedByCampaign = computed(
    () => reportAggregateBy.value === ADS_REPORT_AGGREGATE_BY_TYPES.SOURCE_CAMPAIGN.value,
  );
  const reportIsGroupedByCountry = computed(
    () => reportAggregateBy.value === ADS_REPORT_AGGREGATE_BY_TYPES.COUNTRY.value,
  );
  const reportIsGroupedByRegion = computed(
    () => reportAggregateBy.value === ADS_REPORT_AGGREGATE_BY_TYPES.REGION.value,
  );

  const disableAggregationSort = computed(
    () =>
      reportAggregateBy.value === LISTENING_REPORT_AGGREGATE_BY_TYPES.AGE.value ||
      reportAggregateBy.value === REPORT_PREVIEW_AGGREGATE_BY_TYPES.AGE_GENDER.value,
  );

  return {
    reportIsGroupedByChannel,
    reportIsGroupedByBrand,
    reportIsGroupedByGender,
    reportIsGroupedByPublisherPlatform,
    reportIsGroupedByCampaign,
    reportIsGroupedByCountry,
    reportIsGroupedByRegion,
    reportIsGroupedByCreator,
    disableAggregationSort,
  };
}
